import { lazy } from "react";

const KsNetPaymentSuccess = lazy(() => import("../pages/ksnetPay/KsNetPaymentSuccess"));
const KsNetPaymentFail = lazy(() => import("../pages/ksnetPay/KsNetPaymentFail"));
const KsnetSuccessInterceptor = lazy(() => import("../pages/ksnetPay/interceptors/KsnetSuccessInterceptor"));
const KsnetFailInterceptor = lazy(() => import("../pages/ksnetPay/interceptors/KsnetFailInterceptor"));

export const ksnetPayRoutes = [
  { path: "/ksnet/payment-success", element: <KsNetPaymentSuccess /> },
  { path: "/ksnet/payment-fail", element: <KsNetPaymentFail /> },
  { path: "/ksnet/success-intercepter", element: <KsnetSuccessInterceptor /> },
  { path: "/ksnet/fail-intercepter", element: <KsnetFailInterceptor /> },
];
